import { render } from "./ContactProductsPanel.vue?vue&type=template&id=40619d97"
import script from "./ContactProductsPanel.vue?vue&type=script&lang=js"
export * from "./ContactProductsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__